import { Component, OnInit } from '@angular/core';
import {environment} from '../../../../../environments/environment';
import { Auth } from 'aws-amplify';
import { NgxSpinnerService } from "ngx-spinner";

import { NavigatorService } from '../../../../services/navigator';
import { PatientService } from '../../../../services/patient.service';
import {BasicAgency, RestApiService} from '../../../../services/rest-api.service';
import { PatientData } from '../../../types/patient-data';
import {AdminService} from '../../../../services/admin.service';
import { ToastService } from '../../../custom/messaging/toast/toast.service';

@Component({
  selector: '[class="celerity-app"]',
  templateUrl: './auth-landing.component.html'
})
export class AuthLandingComponent implements OnInit {
  signedIn = false;
  agency = {} as BasicAgency;
  login = { email: '', password: '', error: '' };
  env = environment;

  constructor(private spinner: NgxSpinnerService, private rest: RestApiService, private patient: PatientService,
              private navigator: NavigatorService, private admin:AdminService, private toast:ToastService) {}

  handlePatient(data: PatientData) {
    this.patient.currentPatient = data;
    return this.navigator.redirectToHomePage(data);
  }

  async ngOnInit() {
    this.agency = this.patient.currentAgency;
    if(!this.agency) this.navigator.redirectToAgencyDisabled();
    else {
      try{
        await this.spinner.show();
        const session = await Auth.currentSession();
        this.signedIn = session.isValid();
        if (this.signedIn) {
          const patient = await this.rest.currentPatientData();
          this.handlePatient(patient);
        }
        await this.spinner.hide();
      } catch (err){
        await this.spinner.hide();
        if (err !== 'No current user'){
          this.toast.showDanger("Error!  Current session not able to be loaded.");
          console.log(this.rest.errorMessage(err));
        }
      }
    }
  }

  async signIn() {
    const pw = this.login.password;
    this.login.password = '';
    try {
      await this.spinner.show();
      await Auth.signIn(this.login.email.trim().toLowerCase(), pw);
      const patient = await this.rest.currentPatientData();
      delete this.admin.actAsPatientId; // On a new login, clear the "act as patient" flag
      await this.spinner.hide();
      await this.handlePatient(patient);
    } catch (err) {
      await this.spinner.hide();
      if (err.status === 403)
        this.login.error = 'Your account has been disabled.  Please contact ' + this.agency.name + ' for more details.';
      else if (err.message === 'User does not exist.' || err.message === 'Incorrect username or password.')
        this.login.error = 'Either the e-mail address or password was not correct.  Please try again.';
      else if (err.message === 'Password attempts exceeded') {
        this.login.error = 'Too many login attempts. Please wait and try again later, or use the Forgot password link to reset your password.';
      } else this.login.error = err.message;
      try {
        const session = await Auth.currentSession();
        if (session) return Auth.signOut();
      } catch {
        // Failure is expected if the login failed
      }
    }
    // Sample error objects:
    // {"code":"UserNotFoundException","name":"UserNotFoundException","message":"User does not exist."}
    // {"code":"NotAuthorizedException","name":"NotAuthorizedException","message":"Incorrect username or password."}
  }
}
